//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../components/footer.vue'
import {
  MemberKanbanQuery
} from '../../static/js/api.js'

function loadtotal(that) {

    MemberKanbanQuery({}, function (res) {
        console.log(res)
        if (res.data.IsSuccess) {
            that.loading=false
            that.data = JSON.parse(res.data.Result)
            console.log(that.data)
        } else {

            that.$vux.toast.text('数据获取失败，请重试', 'middle')

        }


    })

}



export default {
  name: 'app',
  components: {
    'pc-footer': Footer,
  },
  data() {
    return {
      loading:true,
      data: {
        PayDetails: {},
        CardTypeNewCardDetails: {},
        CardTypePrepaidDetails: {},
        CardTypeAdjustDetails: {}
      },

      showContent001: true,
      showContent002: false,
      showContent003: false,
      showContent004: false,
      showContent005: false,
      showContent006: false,
        selected:1,

        nav:[
            {
                id:1,
                name:"付款明细"

            },
            {
                id:2,
                name:"办卡明细"

            },
            {
                id:3,
                name:"充值明细"

            },{
                id:4,
                name:"余额调整"

            }


        ],

    }
  },
  created() {
    var that = this
     loadtotal(that)


  },


  methods: {
      change(index){
          console.log(index)
          this.selected= parseInt(index+1)

      },


  }
}



// WEBPACK FOOTER //
// ./src/pages/hjyingyun.vue